export interface StsLanguage {
  locale: string;
  name: string;
}

export interface StsDedicatedFiles {
}

export class StsRootConfigObject {
  enableSearch: boolean;
  enableFavourites: boolean;
  welcomeMessage: string;
  backgroundImage: string;
  loginBackgroundImage: string;
  loginMessage: string;
  languages: StsLanguage[];
  isContentAuthOnly: boolean;
  signInFieldName: string;
  logo: string;
  siteName: string;
  dedicatedFiles: StsDedicatedFiles;
  customCSS: string;
  language: string;
  cliCode?: any;
  demoMode: boolean;
  accessibilityMode: boolean;
  enableChangeUserId: boolean;
  enableEmailCollectionOnLogin: boolean;  // SI flag, if not exists, then false
}
